// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2huqQ","file":"styles_file__1XCOM"};